// extracted by mini-css-extract-plugin
module.exports = {"watchlist":"AddToWatchList_watchlist__PzW0z","watchlistfilled":"AddToWatchList_watchlistfilled__nbHvp","watchlistundobutton":"AddToWatchList_watchlistundobutton__2JCHx"};